// extracted by mini-css-extract-plugin
export default {"Container":"NotificationList_Container__C7KBq"};